import styled from "styled-components";
import { color, typeStyle, units } from "@m/alchemy-theme";
export const Pagination = styled.ul `
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  list-style: none;
  margin: 0;
  padding: 0;

  & li {
    list-style-type: none;
  }
`;
export const PaginationCaption = styled.div `
  ${typeStyle("bodyS")}
  color: ${color("typeBody")};
  margin: ${units(2)} auto auto;
  text-align: center;
`;
export const PaginationWrapper = styled.nav `
  display: inline-flex;
  flex-direction: column;

  & ${Pagination}:empty + ${PaginationCaption} {
    margin-top: 0;
  }
`;
